const LINKED_DEPLOYMENTS_ARCHIVE_ERROR =
  'There are deployments still linked to it.';

export function isLinkedDeploymentsArchiveError(error: unknown): boolean {
  return (
    error instanceof Error &&
    error.message.includes(LINKED_DEPLOYMENTS_ARCHIVE_ERROR)
  );
}
